import { render, staticRenderFns } from "./SlotKiosks.vue?vue&type=template&id=1f5cba1e&scoped=true&"
import script from "./SlotKiosks.vue?vue&type=script&lang=js&"
export * from "./SlotKiosks.vue?vue&type=script&lang=js&"
import style0 from "./SlotKiosks.vue?vue&type=style&index=0&id=1f5cba1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5cba1e",
  null
  
)

export default component.exports